/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Btn_Copynamed1Inputs */

const en_btn_copynamed1 = /** @type {(inputs: Btn_Copynamed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Copy {name}" |
*
* @param {Btn_Copynamed1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_copynamed1 = /** @type {((inputs: Btn_Copynamed1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Copynamed1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_copynamed1(inputs)
});
export { btn_copynamed1 as "btn_copyNamed" }